import Modal from 'react-bootstrap/Modal';
import { usePropertyFilters } from '@providers';
import { lazy, Suspense } from 'react';
import { Button, Placeholder } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const FiltersWidget = lazy(() =>
  import('../../shop/components').then((module) => ({
    default: module.FiltersWidget,
  })),
);

export const PropertyFiltersModal = () => {
  const { t } = useTranslation();

  const { hidePropertyFiltersModal, isPropertyFiltersModalOpen } =
    usePropertyFilters();

  return (
    <Modal
      show={isPropertyFiltersModalOpen}
      onHide={hidePropertyFiltersModal}
      className='ltn__modal-area'
      size='lg'
    >
      <Modal.Header className='px-4 mt-4'>
        <h2>{t('shop.advancedInformation')}</h2>
        <button
          type='button'
          className='close'
          aria-label='Close'
          onClick={hidePropertyFiltersModal}
        >
          <span aria-hidden='true'>&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body className='d-flex flex-column'>
        {isPropertyFiltersModalOpen && (
          <Suspense
            fallback={Array.from({ length: 12 }, (_, i) => (
              <Placeholder key={i} xs={12} animation='wave' />
            ))}
          >
            <FiltersWidget />
            <Button
              variant='primary'
              className='align-self-stretch'
              onClick={hidePropertyFiltersModal}
            >
              {t('propertyPage.showResults')}
            </Button>
          </Suspense>
        )}
      </Modal.Body>
    </Modal>
  );
};
